import { useCategory } from '@checkout/contexts/CategoryContext'

export default function useSubscriptionPlans() {
  const { plans } = useCategory()
  return plans.flat().map( plan => ( {
    'id': plan.id,
    'category': plan.categoria,
    'type': plan.tipo_plano,
    'priceFull': plan.valor_total,
    'pricePerKit': plan.valor_por_kit,
  } ) )
}
